import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import XErrorSvg from '../../../assets/icons/app/x-error.svg?raw';

export const XErrorIcon = (props) => <CustomSVG svg={XErrorSvg} preserveColors appIconSmall {...props} />;
